import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/StockAuthorization.css";
import Header from "../../layouts/Header";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import loading from "../../assets/icons/loading.gif";
import warning from "../../assets/icons/warning.png";
import plusCircle from "../../assets/icons/plusCircle.svg";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import CurrencyInput from "react-currency-input";
import AssigneeModal from "../../components/TaskFilter/AssigneeModal";
import StockAssigneeModal from "./StockAssigneeModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import {
  FetchUserMAXAmount,
  UpdateUserMaxAmount,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";

const StockAuthorization = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const ViewBy_Popup_Ref = useRef(null);
  const filter_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");

  const fetchUserMaxAmountRes = useSelector(
    (state) => state.user.fetchUserMaxAmountRes
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Stock Overview").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // variables state management start.
  const LocalAssineData = JSON.parse(localStorage.getItem("AssineeData")) || [];

  const [authorisedCoWorkerData2, setAuthorisedCoWorkerData2] = useState([
    { firstName: "Ankit", lastName: "Singh", id: "24" },
    { firstName: "Ashu", lastName: "Goel", id: "25" },
    { firstName: "Arun", lastName: "Pratap", id: "26" },
  ]);

  const [authorisedCoWorkerData, setAuthorisedCoWorkerData] = useState([
    // ...LocalAssineData,
  ]);

  console.log("asc56 authData", authorisedCoWorkerData);

  const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
  const [questionMsg, setQuestionMsg] = useState(false);
  const [headerMaxAmount, setHeaderMaxAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");

  useEffect(() => {
    dispatch(FetchUserMAXAmount());
  }, []);

  useEffect(() => {
    if (fetchUserMaxAmountRes.status === true) {
      setAuthorisedCoWorkerData(
        fetchUserMaxAmountRes.data.map((x) => ({
          firstName: x.userfirstname,
          lastName: x.userlastname,
          imageurl: x.userimage,
          maxAmount: x.maxamount,
          id: x.userid,
          type: "single",
        }))
      );
    }
  }, [fetchUserMaxAmountRes]);

  // callback fun() for data passing to child and taking data 👇.
  const addUsersData = (asc, string) => {
    if (string === "single") {
      console.log("asc66", asc, string);
      setAuthorisedCoWorkerData([...authorisedCoWorkerData, asc]);
    }
    if (asc.length > 1) {
      // here ... will add and open asc array.
      setAuthorisedCoWorkerData([...authorisedCoWorkerData, ...asc]);
    }
  };

  const removeUsersData = (asc, string) => {
    if (string === "single") {
      let workers = authorisedCoWorkerData.filter((x) => x.id !== asc.id);
      setAuthorisedCoWorkerData(workers);
    }
    if (asc.length > 1) {
      let workers = authorisedCoWorkerData.filter(
        (x) => !asc.some((user) => user.id === x.id)
      );
      setAuthorisedCoWorkerData(workers);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedCoWorkerData = [...authorisedCoWorkerData];
    updatedCoWorkerData[index][field] = value;

    let workerUserID = updatedCoWorkerData[index].id;
    let workerFirstName = updatedCoWorkerData[index].firstName;
    let workerMaxAmount = updatedCoWorkerData[index].maxAmount;
    console.log("asc56 workerUserID", workerUserID);

    setAuthorisedCoWorkerData(updatedCoWorkerData);

    // dispatch(UpdateUserMaxAmount(workerUserID, workerMaxAmount));
  };

  const handleAddAuthorisedWorker = () => {
    // const array = [];
    // authorisedCoWorkerData.map((item) =>
    //   array.push({ userId: item.id, maxAmount: item.maxAmount || 0 })
    // );

    const array = authorisedCoWorkerData.map((item) => ({
      userId: item.id,
      maxAmount: item.maxAmount || 0,
    }));

    dispatch(UpdateUserMaxAmount(array));
  };

  const handleUpdateAuthorisedWorker = (getUserid) => {
    console.log("asc56 getUserid", getUserid);

    const array = [
      {
        userId: getUserid,
        maxAmount: 0,
      },
    ];

    dispatch(UpdateUserMaxAmount(array));
  };

  return (
    <allSection>
      <Header
        // setQuery={setQuery}
        leftComponent={
          <div className="d-flex align-items-baseline flex-wrap gap-4 pt-2">
            <div
              className="fw-bold Contact-heading"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>

            <div className="pt-2 d-flex pe-3" style={{ background: "#FFFFFF" }}>
              <p className="pt-1 ps-4 invoiceText2">
                {/* Purchasing Order Settings */}
                {t("Purchasing Order Settings")}
              </p>
              {/* <p className="pt-1 projectID ps-5"> &nbsp;{invoiceId} </p> */}
            </div>
          </div>
        }
      />

      <mainSection>
        <div className="d-flex flex-wrap gap-3 justify-content-center pt-2 pe-5">
          <button
            className="mb-0 ms-md-auto cancelBtn ascButton"
            // onClick={() => {
            //   if (typeInScreen !== "") {
            //     setCancelPopupShow(true);
            //   } else {
            //     history.goBack();
            //     // history.push("/InvoiceAllList");
            //   }
            // }}

            onClick={() => {
              history.goBack();
            }}
          >
            {/* Cancel */}
            {t("Cancel")}
          </button>

          <button
            className="mb-0 makeInvoBtn ascButton"
            onClick={() => {
              // localStorage.setItem(
              //   "AssineeData",
              //   JSON.stringify(authorisedCoWorkerData)
              // );

              handleAddAuthorisedWorker();

              setTimeout(() => {
                history.push("/stock");
              }, 1000);
            }}
          >
            {/* Add */}
            {t("Add")}
          </button>
        </div>
      </mainSection>

      <pageSection>
        <div
          className="stockAuthorization m-4 me-5 p-3"
          id="ascSelectBox" // for custom scroll bar.
          style={{ overflow: "auto" }}
        >
          <div
            style={{
              minWidth: "900px",
              maxWidth: "900px",
              whiteSpace: "nowrap",
              maxHeight: "60vh",
            }}
          >
            <div className="d-flex gap-3">
              <div className="position-relative" style={{ width: "45%" }}>
                <p>
                  {/* Authorised Co-worker */}
                  {t("Authorised Co-worker")}
                </p>
                <p className="coWorkerBorder">
                  <img
                    src={plusCircle}
                    className="pointer"
                    alt=""
                    onClick={() => {
                      setOpenAssigneeModal(!openAssigneeModal);
                      // setSearchPeople("");
                    }}
                  />
                </p>

                {openAssigneeModal && (
                  <StockAssigneeModal
                    sendingData={authorisedCoWorkerData} // only sending Data.
                    addUsersData={addUsersData}
                    removeUsersData={removeUsersData}
                    closeAssigneeModal={setOpenAssigneeModal}
                    // headerMaxAmount={headerMaxAmount}
                    // setHeaderMaxAmount={setHeaderMaxAmount}
                    showWorkersTab={true}
                    showTeamsTab={false}
                  />
                )}
              </div>

              <div className="" style={{ width: "15%" }}>
                <p className="position-relative">
                  {/* PO Max amount */}
                  {t("PO Max amount")}
                  <span
                    className="amountSpan ms-1"
                    onMouseOver={() => setQuestionMsg(true)}
                    onMouseOut={() => setQuestionMsg(false)}
                  >
                    ?
                  </span>
                </p>

                {questionMsg && (
                  <p className="amountSpanMsg">
                    {/* Define the maximum value the co-worker is authorised to
                    purchase. Tip: start with the lower value. */}
                    {t(
                      "Define the maximum value the co-worker is authorised to ",
                    )}
                    {t("purchase. Tip: start with the lower value.")}
                  </p>
                )}

                {/* <input
                  type="number"
                  placeholder="Max Amount"
                  className="coWorkerBorder"
                  style={{ width: " -webkit-fill-available" }}
                  value={headerMaxAmount}
                  onChange={(e) => {
                    setHeaderMaxAmount(e.target.value);
                  }}
                /> */}

                {/* {europeanFormatWithSymbol(500)} */}

                <CurrencyInput
                  className="coWorkerBorder pointerEvent"
                  style={{ width: " -webkit-fill-available" }}
                  placeholder="0"
                  // name=""
                  readOnly
                  value={headerMaxAmount}
                  onChangeEvent={(event, maskedValue, floatValue) => {
                    setHeaderMaxAmount(floatValue);
                  }}
                  decimalSeparator=","
                  thousandSeparator="."
                  precision="2"
                  allowEmpty={true}
                  prefix="€ "
                />
              </div>
            </div>

            <div className="">
              {authorisedCoWorkerData.map((item, index) => {
                console.log("asc56 map", item);
                return (
                  <div className="d-flex align-items-center gap-3" key={index}>
                    {/* Authorised Co-worker */}
                    <div className="coWorkerBorder" style={{ width: "45%" }}>
                      {item.imageurl ? (
                        <img
                          src={item.imageurl}
                          className="assigneeImg2"
                          alt=""
                          onError={(e) => {
                            // e.target.src = "img url";
                            e.target.src = warning;
                          }}
                        />
                      ) : (
                        <div className="assigneeAbbr2">
                          {item.lastName
                            ? item?.firstName[0] + "" + item?.lastName[0]
                            : item?.firstName?.slice(0, 2)}
                        </div>
                      )}

                      <p className="mb-0 fname">
                        {item.firstName} &nbsp; {item.lastName ?? ""}
                      </p>
                      <p className="mb-0"> ┃ </p>
                      <p className="mb-0">{item.jobtypename}</p>
                    </div>

                    {/* PO Max amount */}
                    <div style={{ width: "15%" }}>
                      {/* <input
                        type="number"
                        placeholder="Set Max Amount"
                        className="coWorkerBorder"
                        style={{ width: " -webkit-fill-available" }}
                        value={item.maxAmount}
                        onChange={(e) => {
                          handleInputChange(index, "maxAmount", e.target.value);
                        }}
                      /> */}

                      <CurrencyInput
                        className="coWorkerBorder"
                        style={{ width: " -webkit-fill-available" }}
                        placeholder="0"
                        name="maxAmount"
                        value={item.maxAmount}
                        onChangeEvent={(event, maskedValue, floatValue) => {
                          handleInputChange(index, "maxAmount", floatValue);
                        }}
                        // decimalSeparator=","
                        // thousandSeparator="."
                        // precision="2"

                        // for normal input👇
                        decimalSeparator=""
                        thousandSeparator=""
                        precision=""
                        // for normal input👆
                        allowEmpty={true}
                        prefix="€ "
                      />
                    </div>

                    {/* Delete */}
                    <div className="w-25">
                      <img
                        src={deleteIcon}
                        className="pointer mb-3"
                        alt=""
                        onClick={() => {
                          let data = [...authorisedCoWorkerData];
                          data.splice(index, 1);
                          setAuthorisedCoWorkerData(data);

                          // delete api 👇
                          handleUpdateAuthorisedWorker(item.id);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </pageSection>
    </allSection>
  );
};

export default StockAuthorization;
